import React from 'react';
import './styles/Advert.css';

// Define the structure of an advertisement
interface Advertisement {
  id: string;
  imageUrl: string;
  linkUrl: string;
  title: string;
  description: string;
  priceText: string;
}

// List of advertisements
const advertisements: Advertisement[] = [
  {
    id: 'ufc-watch',
    imageUrl: 'https://m.media-amazon.com/images/I/41O-Ltz0ZkL._SL500_.jpg',
    linkUrl: 'https://amzn.to/4jJi3rn',
    title: '🔥 Ultimate UFC Luxury Watch! 🔥',
    description: 'Stand out at any fight night or party<br />with this bold, stylish timepiece.',
    priceText: '💰 See the Price Now!'
  },
  // More advertisements will be added later
];

// Component to display a random advertisement
const AdvertComponent: React.FC = () => {
  // Select a random advertisement from the list
  // For now, always return the first ad since there's only one
  const randomAdvert = advertisements[0];

  return (
    <div className="advert-container">
      <a href={randomAdvert.linkUrl} target="_blank" rel="noopener noreferrer">
        <img className="advert-image" src={randomAdvert.imageUrl} alt={randomAdvert.title} />
      </a>
      <p className="advert-text" dangerouslySetInnerHTML={{ __html: `<strong>${randomAdvert.title}</strong><br />${randomAdvert.description}` }}></p>
      <a className="price-link" href={randomAdvert.linkUrl} target="_blank" rel="noopener noreferrer">{randomAdvert.priceText}</a>
    </div>
  );
};

export default AdvertComponent;